import { Component } from '@angular/core';

@Component({
    selector: 'app-footer-cmp',
    templateUrl: 'footer.component.html',
    standalone: false
})

export class FooterComponent {
    dateTime = new Date();
}
